import { useCallback } from 'react';

export const useMouseUpHandler = (drag: React.MutableRefObject<boolean>) =>
  useCallback(() => {
    drag.current = false;
  }, []);
